import { read, utils } from 'xlsx'; // Import the necessary functions from xlsx
import showdown from 'showdown';
import Highcharts from 'highcharts'


class TableCharts {
  constructor(config = {}) {

    this.table = document.querySelector('[data-tableid="Konso_Bila"]:not(.computed)');
    this.converter = showdown.Converter();
    this.currentOpenElement = null;

    if (this.table) {
      this.table.classList.add('computed')
      this.readExcel().then((data) => {
        if (data !== null) {
          this.setTable(data);
        }
      });
    }
  }

  setTable(data) {

    const rows = this.table.querySelectorAll('tr');
    for(let i = 0; i < rows.length; i++){
      const row = rows[i];
      const entry = data[i];

      if(entry && entry[String(document.documentElement.lang).toUpperCase()] && entry[String(document.documentElement.lang).toUpperCase()].trim().length > 0){

        row.classList.add('table-row-has-info');
        const firstTD = row.querySelector('td:first-child');
        firstTD.innerHTML += `
          <div class="td-info">
            <span class="td-info__icon">
              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="0.5" width="12" height="12" rx="6" fill="#9A0941"/>
              <path d="M6.174 3.902H5.283V3.002H6.174V3.902ZM6.12 9.5H5.337V4.946H6.12V9.5Z" fill="white"/>
              </svg>
            </span>
            <div class="td-info__text">

              `+showdown.makeHtml(entry[String(document.documentElement.lang).toUpperCase()])+`
            </div>
          </div>
        `;

        const info = firstTD.querySelector('.td-info');

        if(!!info){
          this.registerInfo(info);
        }
      }

      if(entry && entry["vorletztesJahr"] && entry["vorvorletztesJahr"]){
        row.classList.add('table-row-has-highchart');
        const div = document.createElement('div');
        div.classList.add('table-chart-trigger');
        div.innerHTML = `<svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="23" height="21.854" rx="1.5" fill="#9A0941"/>
          <rect x="0.5" y="0.5" width="23" height="21.854" rx="1.5" stroke="#9A0941"/>
          <path d="M6.73747 14.854C6.92466 14.854 7.10465 14.782 7.24144 14.6548L10.4692 11.6286C10.5628 11.5398 10.7092 11.5398 10.8028 11.6286L11.89 12.7157C12.5667 13.3637 13.6347 13.3637 14.3138 12.7157L16.1305 10.899C16.1785 10.851 16.2553 10.851 16.3033 10.899L17.1624 11.7558C17.3544 11.9478 17.664 11.9478 17.856 11.7558C17.9448 11.667 17.9976 11.547 18 11.4222V8.48957C18 8.21839 17.7816 8 17.5104 8H14.573C14.3018 8.0072 14.0882 8.23279 14.0954 8.50157C14.0978 8.62636 14.1506 8.74636 14.2394 8.83515L15.1034 9.6991C15.1274 9.7231 15.1394 9.7543 15.1394 9.78549C15.1394 9.81909 15.1274 9.85029 15.1034 9.87189L13.2891 11.6862C13.1955 11.7726 13.0491 11.7726 12.9555 11.6862L11.8684 10.599C11.2156 9.94388 10.1621 9.92468 9.48771 10.5582L6.2335 13.5821C5.93592 13.8581 5.92152 14.3212 6.1975 14.6188C6.3367 14.77 6.53348 14.854 6.73747 14.854Z" fill="white"/>
          </svg>`;
        row.appendChild(div);

        const year1 = this.makeNumbersForMachine(row.querySelector('td:nth-child(3)').innerText);
        const year2 = this.makeNumbersForMachine(row.querySelector('td:nth-child(4)').innerText);
        const year3 = this.makeNumbersForMachine(entry["vorletztesJahr"]);
        const year4 = this.makeNumbersForMachine(entry["vorvorletztesJahr"]);

        const data = [];
        data.push(year4);
        data.push(year3);
        data.push(year2);
        data.push(year1);

        row.addEventListener('click', (event) => {
          if(!event.target.classList.contains('note-link')){
            this.openChart(data, row);
          }
        });

      }

      //rows[i].classList.add('')
    }

    // Update your table with the data here
  }

  openChart(data, row){
    const title = row.querySelector('td:first-child > p');
    const element = document.createElement('div');
    const background = document.createElement('div');
    background.classList.add('highchart-overlay-background');
    element.classList.add('highchart-overlay');
    element.innerHTML = `<button class="highchart-overlay__close">
        <svg class="svg svg-close" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L16.3333 16.3333" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"
        stroke-linejoin="round"></path><path d="M17 1L1 17" stroke="currentColor" stroke-miterlimit="10"
        stroke-linecap="round" stroke-linejoin="round"></path></svg>
      </button>
      <b>`+title.innerHTML+`</b>
    <div id="highchart-container" class="js-table-highchart"></div>`;

    let footnote = false;
    const firstChildSup = row.querySelector('td:first-child sup');
    const table = row.closest('.lc-table-wrap');
    if(!!firstChildSup){
      footnote = table.querySelector('.ns-footnote-container .ns-footnote:nth-child('+firstChildSup.innerText+')');
      element.innerHTML += '<div class="ns-footnote">'+footnote.innerHTML+'</div>';
    }


    document.body.appendChild(background);
    document.body.appendChild(element);

    if (this.currentOpenElement) {
      this.currentOpenElement.remove();
    }
    this.currentOpenElement = element;


    // Adjust popup position
    const rect = row.getBoundingClientRect();
    element.style.left = `${window.innerWidth / 2}px`; // Adjust for horizontal scroll
    element.style.top = `${rect.bottom + window.scrollY}px`; // Adjust for vertical scroll

    // Update close button functionality
    const closeButton = document.querySelector('.highchart-overlay__close');
    const backgroundTrigger = document.querySelector('.highchart-overlay-background');
    const closeFunction = () => {
      element.remove();
      backgroundTrigger.remove();
      if (this.currentOpenElement === element) {
        this.currentOpenElement = null;
      }
    };
    closeButton.addEventListener('click', closeFunction);
    backgroundTrigger.addEventListener('click', closeFunction);




    let highestNumber = Math.max(...data) + 200;
    let lowestNumber = Math.min(...data) - 200;
    if(lowestNumber < 0) lowestNumber = 0;

    const currentYear = 2023;

    Highcharts.chart('highchart-container', {
      chart: {
        type: 'line',
        styledMode: true // Enable styled mode
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: ['31.12.'+(currentYear-3), '31.12.'+(currentYear-2), '31.12.'+(currentYear-1), '31.12.'+currentYear]
      },
      yAxis: {
        min: lowestNumber, // Set the minimum value for the y-axis
        max: highestNumber, // Set the maximum value for the y-axis
        title: {
          text: ''
        },
        labels: {
          formatter: function () {
            return Highcharts.numberFormat(this.value, 0);
          }
        }

      },
      series: [{
        name: 'Data',
        data: data // Your data values for the y-axis
      }],
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      tooltip: {
        enabled: true,
        style: {
          borderColor: '#9A0941', // Set the border color to red
          borderWidth: '2px' // Set the border width
        }
      }
    });


  }

  makeNumbersForMachine(number){
    if(document.documentElement.lang == 'en'){
      return parseFloat(String(number).replace(',', '').trim());
    } else{
      return parseFloat(String(number).replace(',', '.').replace(' ', '').replace('&nbsp;', '').trim());
    }
  }


  registerInfo(info) {
    const background = document.createElement('div');
    background.classList.add('highchart-overlay-background');
    const icon = info.querySelector('.td-info__icon');
    const createTooltip = (content) => {
      // Create tooltip element
      const tooltip = document.createElement('div');
      tooltip.className = 'table-info-tooltip';

      // Create header for the close button
      const header = document.createElement('div');
      header.className = 'tooltip-header';

      if (this.currentOpenElement) {
        this.currentOpenElement.remove();
      }
      this.currentOpenElement = tooltip;


      // Create close button
      const closeButton = document.createElement('button');
      closeButton.className = 'td-info__close';
      closeButton.innerHTML = '<svg class="svg svg-close" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L16.3333 16.3333" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17 1L1 17" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
      closeButton.onclick = function() {
          document.body.removeChild(tooltip);
          document.body.removeChild(background);
      };
      background.onclick = function() {
          document.body.removeChild(tooltip);
          document.body.removeChild(background);
      };

      // Append close button to header
      header.appendChild(closeButton);

      // Append header and content to tooltip
      tooltip.appendChild(header);
      const contentDiv = document.createElement('div');
      contentDiv.className = 'tooltip-content';
      contentDiv.innerHTML = content.innerHTML;
      tooltip.appendChild(contentDiv);

      document.body.appendChild(tooltip);
      document.body.appendChild(background);

      return tooltip;
    };

    const positionAndAdjustTooltip = (tooltip, target) => {
        // Initial position of the tooltip near the target (icon)
        const iconRect = target.getBoundingClientRect();
        tooltip.style.position = 'absolute';
        tooltip.style.left = `${iconRect.left + window.scrollX}px`;
        tooltip.style.top = `${iconRect.bottom + window.scrollY}px`;

        // Adjust position if it overflows the table boundaries
        const tooltipRect = tooltip.getBoundingClientRect();
        const tableRect = this.table.getBoundingClientRect();

        // Adjust for horizontal overflow
        if (tooltipRect.right > tableRect.right) {
            tooltip.style.left = `${tableRect.right - tooltipRect.width + window.scrollX}px`;
        } else if (tooltipRect.left < tableRect.left) {
            tooltip.style.left = `${tableRect.left + window.scrollX}px`;
        }

        // Adjust for vertical overflow
        if (tooltipRect.bottom > tableRect.bottom) {
            tooltip.style.top = `${iconRect.top - tooltipRect.height + window.scrollY}px`;
        } else if (tooltipRect.top < tableRect.top) {
            tooltip.style.top = `${tableRect.top + window.scrollY}px`;
        }
        if(parseInt(tooltip.style.left) < 0){
          tooltip.style.left = 0;
        }
    };

    if (icon) {
        icon.addEventListener('click', (event) => {
            event.stopPropagation();
            const infoText = icon.parentNode.querySelector('.td-info__text');
            const tooltip = createTooltip(infoText);
            positionAndAdjustTooltip(tooltip, icon);

            // Close button functionality within the tooltip
            const closeButton = tooltip.querySelector('.td-info__close');
            closeButton.onclick = function() {
                document.body.removeChild(tooltip);
                document.body.removeChild(background);
            };
        });
    }
  }





  async readExcel() {
    try {
      const response = await fetch(window.projectBase + '/downloads/de/helsana_tablechart.xlsx');

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const arrayBuffer = await response.arrayBuffer();
      const workbook = read(arrayBuffer, { type: 'array', codepage: 65001 }); // Use read function from xlsx

      // Assuming the first sheet contains the data you need
      const targetSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[targetSheetName];

      // Convert the worksheet to an array of objects
      const data = utils.sheet_to_json(worksheet); // Use utils from xlsx
      return data;
    } catch (error) {
      console.error('Error reading Excel:', error);
      return null;
    }
  }
}

export default TableCharts;
